var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "profile_modal",
      attrs: {
        size: "lg",
        bodyClass: "p-0",
        "no-close-on-backdrop": true,
        "hide-header": true,
        dialogClass: _vm.dialog_class_draw,
      },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function ({ close }) {
            return [
              _c(
                "b-button",
                {
                  attrs: { size: "sm", variant: "outline-danger" },
                  on: {
                    click: function ($event) {
                      return close()
                    },
                  },
                },
                [_vm._v("\n            Close Modal\n        ")]
              ),
            ]
          },
        },
        {
          key: "modal-footer",
          fn: function ({ close }) {
            return [
              _c("div", { staticClass: "modal-footer" }, [
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-outline-danger waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.remove_reservation },
                  },
                  [_vm._v("\n                Видалити\n            ")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-secondary waves-effect waves-themed",
                    attrs: { type: "button" },
                    on: { click: _vm.close_mod },
                  },
                  [_vm._v("\n                Закрити\n            ")]
                ),
              ]),
            ]
          },
        },
      ]),
      model: {
        value: _vm.is_show_modal,
        callback: function ($$v) {
          _vm.is_show_modal = $$v
        },
        expression: "is_show_modal",
      },
    },
    [
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "panel mb-0 border-bottom-0 shadow-none",
          attrs: { id: "panel_user_list" },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0",
            },
            [
              _vm.cur_item.id > 0
                ? _c("h2", [
                    _c("span", { staticClass: "fw-300" }, [
                      _vm._v(
                        "ID:" +
                          _vm._s(this.cur_item.id) +
                          " | " +
                          _vm._s(this.cur_item.zal)
                      ),
                    ]),
                  ])
                : _c("h2", [_vm._v("\n                -\n            ")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "panel-toolbar pr-3 pb-2 align-self-end" },
                [
                  _c(
                    "button",
                    {
                      staticClass:
                        "btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed",
                      on: {
                        click: function ($event) {
                          return _vm.close()
                        },
                      },
                    },
                    [_c("i", { staticClass: "fal fa-times" })]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "panel-container show" }, [
            _c("div", { staticClass: "reserv_info" }, [
              _c("div", { staticClass: "info_time" }, [
                _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("ПІБ")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "action" }, [
                    _vm._v(
                      "\n                           " +
                        _vm._s(this.cur_item.name) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clr" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Комент")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "action" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(this.cur_item.coment) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clr" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Початок Бронювання"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "action" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(this.cur_item.date_pick) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clr" }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "block" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Кiнець Бронювання"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "action" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(this.cur_item.date_end) +
                        "\n                        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clr" }),
                ]),
              ]),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }